"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRpcQueryExtension = exports.QueryClientImpl = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _m0 = _interopRequireWildcard(require("protobufjs/minimal"));
var _stargate = require("@cosmjs/stargate");
var _query = require("./query");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var QueryClientImpl = /*#__PURE__*/function () {
  function QueryClientImpl(rpc) {
    (0, _classCallCheck2["default"])(this, QueryClientImpl);
    (0, _defineProperty2["default"])(this, "rpc", void 0);
    this.rpc = rpc;
    this.exchangeRate = this.exchangeRate.bind(this);
    this.exchangeRates = this.exchangeRates.bind(this);
    this.actives = this.actives.bind(this);
    this.voteTargets = this.voteTargets.bind(this);
    this.priceSnapshotHistory = this.priceSnapshotHistory.bind(this);
    this.twaps = this.twaps.bind(this);
    this.feederDelegation = this.feederDelegation.bind(this);
    this.votePenaltyCounter = this.votePenaltyCounter.bind(this);
    this.slashWindow = this.slashWindow.bind(this);
    this.params = this.params.bind(this);
  }
  (0, _createClass2["default"])(QueryClientImpl, [{
    key: "exchangeRate",
    value: function exchangeRate(request) {
      var data = _query.QueryExchangeRateRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "ExchangeRate", data);
      return promise.then(function (data) {
        return _query.QueryExchangeRateResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "exchangeRates",
    value: function exchangeRates() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QueryExchangeRatesRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "ExchangeRates", data);
      return promise.then(function (data) {
        return _query.QueryExchangeRatesResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "actives",
    value: function actives() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QueryActivesRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "Actives", data);
      return promise.then(function (data) {
        return _query.QueryActivesResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "voteTargets",
    value: function voteTargets() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QueryVoteTargetsRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "VoteTargets", data);
      return promise.then(function (data) {
        return _query.QueryVoteTargetsResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "priceSnapshotHistory",
    value: function priceSnapshotHistory() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QueryPriceSnapshotHistoryRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "PriceSnapshotHistory", data);
      return promise.then(function (data) {
        return _query.QueryPriceSnapshotHistoryResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "twaps",
    value: function twaps(request) {
      var data = _query.QueryTwapsRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "Twaps", data);
      return promise.then(function (data) {
        return _query.QueryTwapsResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "feederDelegation",
    value: function feederDelegation(request) {
      var data = _query.QueryFeederDelegationRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "FeederDelegation", data);
      return promise.then(function (data) {
        return _query.QueryFeederDelegationResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "votePenaltyCounter",
    value: function votePenaltyCounter(request) {
      var data = _query.QueryVotePenaltyCounterRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "VotePenaltyCounter", data);
      return promise.then(function (data) {
        return _query.QueryVotePenaltyCounterResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "slashWindow",
    value: function slashWindow() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QuerySlashWindowRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "SlashWindow", data);
      return promise.then(function (data) {
        return _query.QuerySlashWindowResponse.decode(new _m0.Reader(data));
      });
    }
  }, {
    key: "params",
    value: function params() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = _query.QueryParamsRequest.encode(request).finish();
      var promise = this.rpc.request("seiprotocol.seichain.oracle.Query", "Params", data);
      return promise.then(function (data) {
        return _query.QueryParamsResponse.decode(new _m0.Reader(data));
      });
    }
  }]);
  return QueryClientImpl;
}();
exports.QueryClientImpl = QueryClientImpl;
var createRpcQueryExtension = function createRpcQueryExtension(base) {
  var rpc = (0, _stargate.createProtobufRpcClient)(base);
  var queryService = new QueryClientImpl(rpc);
  return {
    exchangeRate: function exchangeRate(request) {
      return queryService.exchangeRate(request);
    },
    exchangeRates: function exchangeRates(request) {
      return queryService.exchangeRates(request);
    },
    actives: function actives(request) {
      return queryService.actives(request);
    },
    voteTargets: function voteTargets(request) {
      return queryService.voteTargets(request);
    },
    priceSnapshotHistory: function priceSnapshotHistory(request) {
      return queryService.priceSnapshotHistory(request);
    },
    twaps: function twaps(request) {
      return queryService.twaps(request);
    },
    feederDelegation: function feederDelegation(request) {
      return queryService.feederDelegation(request);
    },
    votePenaltyCounter: function votePenaltyCounter(request) {
      return queryService.votePenaltyCounter(request);
    },
    slashWindow: function slashWindow(request) {
      return queryService.slashWindow(request);
    },
    params: function params(request) {
      return queryService.params(request);
    }
  };
};
exports.createRpcQueryExtension = createRpcQueryExtension;